export default "__VITE_ASSET__xKTOeMY3__"